var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.allow_vi_question_random)?_c('vacancy-videointerview-navigation'):_c('router-view')
}
var staticRenderFns = []

export { render, staticRenderFns }